import { useNavigate } from "react-router-dom";
import { useRef } from "react";

/* eslint-disable camelcase */
import classNames from "classnames";

// Components
import Button from "components/atoms/Button";
import PageTitle from "components/atoms/PageTitle";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";
import useTranslate from "hooks/useTranslate";
import useScrollDetection from "hooks/useScrollDetection";

// Images
import Money_100 from "assets/images/banger/info_100.webp";
import Spin_250 from "assets/images/banger/info_250_FS.webp";
import Box from "assets/images/banger/info_box.webp";
import GloryMoney_100 from "assets/images/glory/info_100.webp";
import Glory125 from "assets/images/glory/info_125.webp";
import GlorySpin250 from "assets/images/glory/info_FS.webp";
import { useRouterHistoryStore } from "stores/routerHistory";
import { WelcomeBonusCurrencyBlockValues } from "types/WelcomeBonus";

import "./styles.sass";

type WelcomeBonusInfoFirstProps = {
  currencyValues: WelcomeBonusCurrencyBlockValues;
  onClick: () => void;
};

const WelcomeBonusInfoFirst = (props: WelcomeBonusInfoFirstProps) => {
  const { currencyValues, onClick } = props;
  const t = useTranslate();
  const { isDesktop } = useBreakpoint();
  const navigate = useNavigate();
  const contentRef = useRef<HTMLDivElement>(null);
  const isScrolled = useScrollDetection();

  const previousPage = useRouterHistoryStore((state) => state.previous);

  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  const BlockClass = classNames("WelcomeBonusInfoFirst-advert", {
    "WelcomeBonusInfoFirst-small": !isDesktop,
  });
  const HeaderClass = classNames("WelcomeBonusInfoFirst-first__header", {
    border: isScrolled,
  });

  const image125 = VITE_APP_PROJECT_NAME === "glory" ? Glory125 : Box;
  const image100 =
    VITE_APP_PROJECT_NAME === "glory" ? GloryMoney_100 : Money_100;
  const imageFS = VITE_APP_PROJECT_NAME === "glory" ? GlorySpin250 : Spin_250;

  return (
    <div className="WelcomeBonusInfoFirst" ref={contentRef}>
      <div className="WelcomeBonusInfoFirst-first">
        {isDesktop ? (
          <span className="WelcomeBonusInfoFirst-first__title">
            {t(`info.promo.welcome.title.${VITE_APP_PROJECT_NAME}`)}
          </span>
        ) : (
          <div className={HeaderClass}>
            <PageTitle
              title="menu.left.welcomebonus"
              onBack={() => navigate(previousPage)}
            />
          </div>
        )}
        {!isDesktop && (
          <>
            <span className="WelcomeBonusInfoFirst-first__secondTitle">
              {t(
                `info.promo.welcome.title.secondTitle.${VITE_APP_PROJECT_NAME}`,
              ).toUpperCase()}
            </span>
            <span className="WelcomeBonusInfoFirst-first__secondRow">
              {t("info.promo.welcome.title.gift").toUpperCase()}
            </span>
          </>
        )}
        <span className="WelcomeBonusInfoFirst-first__desc">
          {t(`info.promo.welcome.description.first.${VITE_APP_PROJECT_NAME}`)}{" "}
          {currencyValues && currencyValues.block1}{" "}
          {t("info.promo.welcome.description.second")}
        </span>

        <span className="WelcomeBonusInfoFirst-first__desc">
          {t(
            `info.promo.welcome.description.extra.first.${VITE_APP_PROJECT_NAME}`,
          )}{" "}
          {currencyValues && currencyValues.block2}{" "}
          {t(
            `info.promo.welcome.description.extra.second.${VITE_APP_PROJECT_NAME}`,
          )}
        </span>

        <div className="WelcomeBonusInfoFirst-first__button">
          <Button
            variation="primary"
            label="info.promo.welcome.button"
            className="WelcomeBonusInfoFirst-first__button_size"
            // eslint-disable-next-line react/jsx-handler-names
            onClick={onClick}
          />
        </div>
      </div>
      <div className={BlockClass}>
        <span className="WelcomeBonusInfoFirst-advert__title">125%</span>
        <span className="WelcomeBonusInfoFirst-advert__desc">
          {t("info.promo.welcome.description.125")}
        </span>
        <img
          className="WelcomeBonusInfoFirst-advert__img first"
          src={image125}
          alt="box"
        />
      </div>
      <div className="WelcomeBonusInfoFirst-third">
        <div className="WelcomeBonusInfoFirst-small">
          <span className="WelcomeBonusInfoFirst-advert__title">100%</span>
          <span className="WelcomeBonusInfoFirst-advert__desc">
            {t("info.promo.welcome.description.new.100")}
          </span>
          <img
            className="WelcomeBonusInfoFirst-advert__img"
            src={image100}
            alt="box"
          />
        </div>
        <div className="WelcomeBonusInfoFirst-small">
          <span className="WelcomeBonusInfoFirst-advert__title">+250 FS</span>
          <span className="WelcomeBonusInfoFirst-advert__desc">
            {t("info.promo.welcome.description.new.freespin.first")}{" "}
            {currencyValues && currencyValues.block3}{" "}
            {t("info.promo.welcome.description.new.freespin.second")}
          </span>
          <img
            className="WelcomeBonusInfoFirst-advert__img"
            src={imageFS}
            alt="box"
          />
        </div>
      </div>
    </div>
  );
};

export default WelcomeBonusInfoFirst;
